import MiniCalendar from "components/calendar/MiniCalendar";
import WeeklyRevenue from "views/admin/default/components/WeeklyRevenue";
import TotalSpent from "views/admin/default/components/TotalSpent";
import PieChartCard from "views/admin/default/components/PieChartCard";
import { IoMdHome } from "react-icons/io";
import { MdBarChart } from "react-icons/md";
import { IoQrCode, IoDocuments, IoLogoGithub } from "react-icons/io5";
import { SiVercel } from "react-icons/si";
import { columnsDataCheck, columnsDataComplex } from "./variables/columnsData";

import Widget from "components/widget/Widget";
import CheckTable from "views/admin/default/components/CheckTable";
import ComplexTable from "views/admin/default/components/ComplexTable";
import DailyTraffic from "views/admin/default/components/DailyTraffic";
import TaskCard from "views/admin/default/components/TaskCard";
import tableDataCheck from "./variables/tableDataCheck.json";
import tableDataComplex from "./variables/tableDataComplex.json";

const Dashboard = () => {
  return (
    <div>
      {/* Card widget */}

      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
        <Widget
  icon={<IoDocuments className="h-7 w-7" />}
  title={"Help You"}
  subtitle={
    <div>
      <a href="https://github.com/NjabuloAI/Njabulo-Jb/stargazers" target="_blank" rel="noopener noreferrer">
      <img src="https://img.shields.io/github/stars/NjabuloAI/Njabulo-Jb?style=social" alt="GitHub stars" />
      </a>
      <a href="https://github.com/NjabuloAI/Njabulo-Jb/network/members" target="_blank" rel="noopener noreferrer">
      <img src="https://img.shields.io/github/forks/NjabuloAI/Njabulo-Jb?style=social" alt="GitHub forks" />
      </a>
       <a href="https://github.com/NjabuloAI/Njabulo-Jb" target="_blank" rel="noopener noreferrer">
        <img src="https://img.shields.io/badge/GitHub-Repository-blue?style=social" alt="Njabulo Jb" />
      </a>
    </div>
  }
/>
        <Widget
       icon={<IoQrCode className="h-6 w-6" />}
      title={"Linked Device"}
     subtitle={
    <div>
      <a href="https://scan-pair.onrender.com" target="_blank" rel="noopener noreferrer">
        <img src="https://img.shields.io/badge/Pair-Code-blue?style=social" alt="Pair Code" />
      </a>
      <a href="https://scan-pair.onrender.com/qr" target="_blank" rel="noopener noreferrer" style={{ marginLeft: 10 }}>
        <img src="https://img.shields.io/badge/QR-Code-green?style=social" alt="QR Code" />
      </a>
    </div>
  }
/>
   <Widget
  icon={<SiVercel className="h-6 w-6" />}
  title={"Deploy Njabulo Jb"}
  subtitle={
    <div>
      <a href="https://dashboard.heroku.com/new?template=https://github.com/NjabuloAI/fana-md" target="_blank" rel="noopener noreferrer">
        <img src="https://img.shields.io/badge/Heroku-Deploy-purple?style=social&logo=heroku" alt="Heroku" />
      </a>
      <a href="https://dashboard.render.com" target="_blank" rel="noopener noreferrer">
        <img src="https://img.shields.io/badge/Render-Deploy-blue?style=social&logo=render" alt="Render" />
      </a>
      </div>
      }
      />    
      </div>


      {/* Tables & Charts */}

      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-2">
        {/* Check Table */}
        <div>
          <CheckTable
            columnsData={columnsDataCheck}
            tableData={tableDataCheck}
          />
        </div>

        {/* Complex Table , Task & Calendar */}

        <ComplexTable
          columnsData={columnsDataComplex}
          tableData={tableDataComplex}
        />

        {/* Task chart & Calendar */}

        <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
          <TaskCard />
          <div className="grid grid-cols-1 rounded-[20px]">
            <MiniCalendar />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
